<template>
    <div>
      <div class="text-right">
      </div>
    </div>
  </template>
  <script>
  export default {
    components: {
    },
    data() {
      return {
        isIos: null,
        isAndroid: null,
        isIosUrl: 'https://apps.apple.com/cn/app/id1523009207',
        isAndroidUrl: 'https://play.google.com/store/apps/details?id=',
        androidBags:{
          '2001':'com.layla.chat',
          '2002':'com.layla.cybo.ai',
          '2003':'com.layla.hw.chat',
          '2004':'com.layla.chat.a',
          '2005':'com.layla.chat4',
          '2006':'com.layla.ohla',
          '1001':'com.sy.pocket',
          '1002':'com.sy.pocket.lite',
          '1003':'com.sy.pocket.sau',
          '1004':'com.sy.pocket.mex',
          '1005':'com.sy.pocket.chl',
          '1006':'com.sy.pocket.tur',
        },
        fid:''
      };
    },
    created() {
      var u = navigator.userAgent;
      var isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
      this.isIos = isIos
      this.isAndroid = isAndroid
      this.fid = this.$route.query.fid || '2001' // 假设fid存在，可以从url中获取fid的值
    },
    mounted() {
        this.download()
    },
    methods: {
      download() {
        if (this.isAndroid) {
          window.location.href = this.isAndroidUrl + this.androidBags[this.fid]
        } else if (this.isIos) {
          window.location.href = this.isIosUrl
        }
      }
    },
  };
  
  </script>
  
  <style>
  * {
    margin: 0;
    padding: 0;
  }
  </style>